import {
  MenuItemProps,
  MenuItem,
  MenuItemSpacer,
  MenuItemTrailingIcon,
  MenuItemTypography,
} from 'patient-ping-remedy/packages/menu';
import Checkbox from 'patient-ping-remedy/packages/checkbox';
import ToolTip from 'patient-ping-remedy/packages/tool-tip';
import {ICONS} from 'patient-ping-remedy/packages/icon';
import {Roster, User} from '@/api/dto/dto';
import AvatarDetails from '@common/AvatarDetails';
import Loading from '@common/Loading';
import {LoadingWrapper} from '@common/AssignedToItem.styles';
import DisplayHelpers from '@/helpers/display_helpers';

type Props = MenuItemProps & {
  user: Partial<User>;
  roster: Roster | null;
  assigned: boolean;
  loading: boolean;
  disabled: boolean;
  blocked?: boolean;
  own?: boolean;
  onAssign(user: Partial<User>): Promise<void>;
}

export default function AssignedToItem({ user, roster, assigned, loading, disabled, blocked, own, onAssign, ...props }: Props) {
  return (
    <MenuItem
      data-assigned-item
      disabled={disabled || blocked}
      onClick={() => onAssign(user)}
      {...props}
    >
      {loading ? (
        <LoadingWrapper>
          <Loading iconSize="lg" />
        </LoadingWrapper>
      ) : <Checkbox value={assigned} disabled={disabled || blocked} />}
      <AvatarDetails user={user} roster={roster} />
      {own ? (
        assigned ? (
          <MenuItemTypography active>
            {user.first_name} {user.last_name}{' '}
            <MenuItemTypography>(assign to me)</MenuItemTypography>
          </MenuItemTypography>
        ) : <MenuItemTypography>Assign to me</MenuItemTypography>
      ) : (
        <MenuItemTypography>
          {user.first_name} {user.last_name}
        </MenuItemTypography>
      )}
      {blocked && (
        <>
          <MenuItemSpacer />
          <ToolTip text={DisplayHelpers.contactAdminMessage()} type="dark">
            <MenuItemTrailingIcon iconClass={ICONS['info-circle']} />
          </ToolTip>
        </>
      )}
    </MenuItem>
  );
}
